<div class="file-upload-page">
  <div class="file-type">
    {{ file.title | translateValue }}
    <span *ngIf="file.title && file.title.toLowerCase().includes('bite') && isUploadYourDesign">or Your Design</span>
    <ng-container *ngIf="!required">({{ 'general.optional' | translate }})</ng-container>
  </div>

  <div class="file-content" *ngIf="!value?.length || multiple">
    <ng-container *ngTemplateOutlet="uploadImage"></ng-container>

    <div
      appDragDrop
      class="upload-wrapper"
      [class.has-files]="value?.length"
      (onFileDropped)="onFileDrop($event)"
      (click)="fileInput.click()"
    >
      <input
        #fileInput
        type="file"
        [accept]="acceptAttribute"
        [multiple]="multiple"
        (change)="changeTrigger($event.srcElement)"
      />

      <p class="upload-file-title">
        {{ 'general.upload' | translate }} [{{ file.accept }}]
        {{ 'general.file'.toLowerCase() | translate | lowercase }}
      </p>
      <div class="upload-file-info">
        <P
          *ngIf="showCloudDrive$ | async"
          class="cloud-drive"
          (click)="cloudDriveEvent.emit(); $event.stopPropagation()"
        >
          {{ 'general.access' | translate }}&nbsp;
          <span>{{ 'general.cloudDrive' | translate }}</span>
          {{ 'general.or' | translate }}&nbsp;
        </P>
        <p
          class="upload-file-action upload-file-action-desktop"
          [innerHTML]="'general.dragAndDropScanUpload' | translate | safe: 'html'"
        ></p>
        <p class="upload-file-action upload-file-action-mobile">{{ 'general.browseFiles' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="file-content" *ngIf="value?.length && !multiple">
    <ng-container *ngTemplateOutlet="uploadImage"></ng-container>

    <ng-container *ngFor="let file of value">
      <div *ngIf="value?.length" class="upload-success" [class.in-progress]="file.inProgress">
        <div class="upload-success-file">
          <img src="assets/images/file-types/stl.webp" />
          <span>{{ file.name | translate }}</span>
          <img (click)="removeFile(file)" src="assets/images/common/close.svg" />
        </div>
      </div>
      <div class="upload-progressbar">
        <p-progressbar *ngIf="file.inProgress" [value]="file.progress" />
      </div>
    </ng-container>
  </div>

  <div class="file-multiple" *ngIf="value?.length && multiple">
    <ng-container *ngFor="let file of value">
      <div *ngIf="value?.length" class="upload-success" [class.in-progress]="file.inProgress">
        <div class="upload-success-file">
          <img src="assets/images/file-types/stl.webp" />
          <span>{{ file.name | translate }}</span>
          <img (click)="removeFile(file)" src="assets/images/common/close.svg" />
        </div>
      </div>
      <div class="upload-progressbar" *ngIf="file.inProgress">
        <p-progressbar [value]="file.progress" />
      </div>
    </ng-container>
  </div>

  <div class="upload-errors" role="alert" *ngIf="hasError">
    <p *ngIf="displayAcceptError">{{ 'general.uploadScansWrongType' | translate: { types: file.accept } }}</p>
    <p *ngIf="displaySingleFileOnlyError">{{ 'general.uploadScansSingleFileOnly' | translate }}</p>
    <p *ngIf="displayMaxFilesCountError">
      {{ 'general.uploadScansTooManyFiles' | translate: { count: maxFilesCount } }}
    </p>
    <p *ngIf="displayMinBitesError">{{ 'general.uploadScansFileTooSmall' | translate }}</p>
    <p *ngIf="displayConversionError">{{ 'general.uploadScansHeicFailed' | translate }}</p>
    <p *ngIf="maxSizeExceeded">{{ 'general.uploadScansTooLarge' | translate: { size: maxMegabytes } }}</p>
  </div>
</div>

<ng-template #uploadImage>
  <div class="image-wrapper">
    <img *ngIf="imagePath" [src]="imagePath" alt="upload-image" />
  </div>
</ng-template>
